"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexColumn = exports.FlexRow = void 0;
var react_1 = __importDefault(require("react"));
var Flex = function (_a) {
    var children = _a.children, _b = _a.direction, direction = _b === void 0 ? 'column' : _b, _c = _a.justifyContent, justifyContent = _c === void 0 ? 'space-between' : _c, _d = _a.alignItems, alignItems = _d === void 0 ? 'start' : _d, rest = __rest(_a, ["children", "direction", "justifyContent", "alignItems"]);
    return (react_1.default.createElement("div", { style: {
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: direction,
            justifyContent: justifyContent,
            alignItems: alignItems,
            alignContent: rest.alignContent,
            gap: rest.gap,
            flexWrap: rest.wrap,
            minHeight: rest.minHeight,
            height: rest.height,
            maxHeight: rest.maxHeight,
            minWidth: rest.minWidth,
            width: rest.width || '100%',
            maxWidth: rest.maxWidth,
        } }, children));
};
var FlexRow = function (_a) {
    var rest = __rest(_a, []);
    return (react_1.default.createElement(Flex, __assign({ direction: "row" }, rest)));
};
exports.FlexRow = FlexRow;
var FlexColumn = function (_a) {
    var rest = __rest(_a, []);
    return (react_1.default.createElement(Flex, __assign({ direction: "column" }, rest)));
};
exports.FlexColumn = FlexColumn;
